import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { Provider as StyletronProvider } from "styletron-react";
import { Client as Styletron } from "styletron-engine-monolithic";
import RawFrameTest from "./components/Viewer/RawFrameTest";
import Body from "./components/Body";
import PricingPage from "./pages/Pricing";

const engine = new Styletron();

const MainApp = () => {
  return (
    <div className="w-screen h-screen flex flex-col overflow-hidden">
      <Body />
    </div>
  );
};

function App() {
  return (
    <StyletronProvider value={engine}>
      <Router>
        <Routes>
          <Route path="/" element={<MainApp />} />
          <Route path="/test" element={<RawFrameTest />} />
          <Route path="/pricing" element={<PricingPage />} />
        </Routes>
      </Router>
    </StyletronProvider>
  );
}

export default App;
